import store from '../store'
import {includes} from 'lodash'
import auth from '../domain/auth/services/auth'

const isAuthRoute = route => route.path.indexOf('/auth') !== -1
const isLogged = () => store.getters.isLogged
const publicRoutes = ['/recuperar'] // insert public routes here

export default (to, from, next) => {
  if (!isAuthRoute(to) && !isLogged() && !includes(publicRoutes, to)) {
    if (auth.loggedIn()) { // O usuário está logado (localStorage cache) mas as informações não estão no store
      store.dispatch('attemptLogin', {
        email: ':)',
        password: 'hacker'
      })
        .then(() => {
          next()
        })
    } else {
      next({
        path: '/auth',
        query: {redirect: to.fullPath}
      })
    }
  } else {
    next()
  }
}



// WEBPACK FOOTER //
// ./src/router/beforeEach.js